import { rgba } from 'polished'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

interface IStyleProps {}

export default makeStyles<Theme, IStyleProps>(_theme => ({
  root: {
    paddingRight: 20,
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      paddingRight: 40
    },
    '&:hover': {
      '& $removeButton': {
        display: 'block'
      },
      '& $highlight': {
        display: 'block'
      },
      '& .MuiInputBase-root:not(:hover)': {
        backgroundColor: 'transparent'
      }
    }
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 5,
    [theme.breakpoints.down('xs')]: {
      '& :nth-child(2)': {
        marginLeft: 8
      }
    }
  },
  highlight: {
    display: 'none',
    width: '110%',
    height: '120%',
    transform: 'translateY(-10px) translateX(-20px)',
    position: 'absolute',
    backgroundColor: rgba(0, 0, 0, 0.05),
    borderRadius: 5,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      transform: 'unset'
    }
  },
  removeButton: {
    display: 'none',
    position: 'absolute',
    top: 20,
    right: 15,
    cursor: 'pointer',
    transform: 'translateY(-50%)',
    [theme.breakpoints.down('md')]: {
      right: 5
    }
  },
  degreeTypeMenu: {
    maxHeight: 200
  },
  schoolListbox: {
    borderRadius: 20,
    fontSize: 12
  }
}))
